export default {
  en: {
    title: 'Welcome to the CBX Blog',
    subtitle: 'Where travel, destinations and people connect',
  },
  es: {
    title: 'Bienvenido al Blog de CBX',
    subtitle: 'El lugar donde los viajes, destinos y las personas se conectan',
  }
};
